export default __webpack_public_path__ + "static/BreeSerif-Light-9dbcda45bbd341e3224b0c61b6e8a3a9.woff";